import styled from 'styled-components';

export const FilterListItemWrapper = styled.ul`
  margin-top: 23px;
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  padding: 20px 0 0;
  list-style: none;
`;
